import { empty, type, contains } from "./common";

let _ = require("lodash");

export function removeAt(l, p) {
  let le = l.length;
  if (p < 0 || p >= le) return;
  for (let i = p; i < le - 1; i++) l[i] = l[i + 1];
  return l.pop();
}

export function remove(l, f) {
  let index = indexOf(l, f);
  removeAt(l, index);
}

export function push(l, t) {
  if (type(t) === "array") {
    t.forEach((c) => l.push(c));
    return;
  }
  l.push(t);
}

export function insert(l, i, t) { //相当于是insertBefore
  l.splice(i, 0, t);
  return l;
}


export function insertAfter(l, i, t) {
  let lastIndex = l.length-1;
  if(i>=lastIndex) {l.push(t); return l};
  return insert(l,i+1,t);
}

export function indexOf(l, f) {
  for (let i = 0; i < l.length; i++) {
    let o = l[i];
    if (f(o, i)) {
      return i;
    }
  }
  return -1;
}

export function diff(arr1, arr2, f) {
  //取交集
  let diff = [];
  let tmp = [...arr2];
  let _indexOf = (l, v) => {
    return indexOf(l, t => {
      return f(v, t);
    });
  };

  arr1.forEach(function (val1, i) {
    if (_indexOf(arr2, val1) < 0) {
      diff.push(val1);
    } else {
      tmp.splice(_indexOf(tmp, val1), 1);
    }
  });

  return diff.concat(tmp);
}

export function exchange(array, index0, index1) {
  //将index0和index1位置上的元素互换
  let temp = array[index0];
  array[index0] = array[index1];
  array[index1] = temp;
  return array;
}

export function objectMembersToArray(obj, filter, del = true) {
  //将对象的成员转换成数组,del:是否删除成员
  if (type(filter) === "array") {
    let exists = filter;
    filter = key => exists.contains(key);
  }

  let members = [];
  let keys = [];
  for (let e in obj) {
    if (filter(e)) {
      members.push(obj[e]);
      keys.push(e);
    }
  }
  if (del) {
    keys.forEach(key => {
      delete obj[key];
    });
  }

  return members;
}

export function order(l, func, t) { //type:asc desc
  if (!t) t = "asc";
  var m = {};
  var ef = t === "asc" ? function (a, b) { return a < b; } : function (a, b) { return a > b; };
  for (var i = 0; i < l.length; i++) {
    for (var k = 0; k < l.length; k++) {
      if (ef(func(l[i]), func(l[k]))) {
        m = l[k];
        l[k] = l[i];
        l[i] = m;
      }
    }
  }
  return l;
}


//先进先出 – 队列效果（后面的数据把前面的数据往前顶）
export function Queue() {

  let _list = [];

  this.add = (item) => {
    _list.unshift(item);
  }

  //移除最早加入的一个元素
  this.remove = () => {
    _list.pop();
  }

  this.half = () => { //数据减半
    let total = _list.length;
    if (total < 2) return;
    let end = parseInt(total / 2); //把最先加入的数据剔除掉
    _list = _list.slice(0, end);
  }

  this.find = (predicate) => {
    return _.find(_list, predicate);
  }

  this.filter = (predicate) => {
    return _.filter(_list, predicate);
  }

  this.count = () => _list.length;
}

//先进后出 – 堆栈效果（后面进来的数据先出去）
export function Stack() {

  const _list = [];

  this.add = (item) => {
    _list.push(item);
  }

  //移除最晚加入的一个元素
  this.remove = () => {
    _list.pop();
  }

  this.find = (predicate) => {
    return _.find(_list, predicate);
  }

  this.filter = (predicate) => {
    return _.filter(_list, predicate);
  }

  this.count = () => _list.length;
}


export { contains };